import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Input,
  FormGroup,
  FormText,
  Form,
} from "reactstrap";
import {
  Search,
  Briefcase,
  Award,
  Building,
  Star,
  ArrowRigh,
  Check,
  Gift,
  Users,
  MapPin,
} from "react-feather";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ProfileAction } from "../../Store/Actions/ProfileAction";
import CommonModal from "../../Components/CommonModal";
import BasicProfileContent from "../../Components/BasicProfileContent";
import BrowseJobs from "../../Components/BrowseJobs";
import TopHiring from "../../Components/TopHiring";
import { Link } from "react-router-dom/cjs/react-router-dom";
import TestimonialCarousel from "../../Components/TestimonialComponent";
import BannerCarousel from "../../Components/BannerHome";
import { FaCoins } from "react-icons/fa";
import { BANNER_BG, PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
import SearchJob from "../../Components/SearchJob";
import AliceCarousel from "react-alice-carousel";
import { delay } from "../../Helper/ToastDelay";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import Notiflix from "notiflix";
import { toast } from "react-toastify";
import PostApiCall from "../../Api/Api";
import InteractiveJobCard from "../../Components/InteractiveJobCard";

const HomePage = () => {
  const [jobTitle, setJobTitle] = useState("");

  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const profile = useSelector((state) => state.profile);
  const [jobsData, setJobsData] = useState([]);
  const items = [
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/dabur.png"
        alt=""
        role="presentation"
      />
    </div>,
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/airtel.jpg"
        className="mt-3"
        alt=""
        role="presentation"
      />
    </div>,
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/m&s.jpg"
        alt=""
        role="presentation"
      />
    </div>,
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/del.png"
        alt=""
        role="presentation"
      />
    </div>,
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/oyo.png"
        alt=""
        role="presentation"
      />
    </div>,
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/paytm.png"
        alt=""
        role="presentation"
      />
    </div>,
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/reliance.jpg"
        alt=""
        role="presentation"
      />
    </div>,
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/bajaj.png"
        alt=""
        role="presentation"
        className="mt-3"
      />
    </div>,
    <div style={{ width: "100px", padding: "5px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/client/m3m.png"
        alt=""
        role="presentation"
      />
    </div>,
  ];

  const responsive = {
    0: {
      items: 2,
    },
    768: {
      items: 4,
    },
    1024: {
      items: 6,
      itemsFit: "contain",
    },
  };

  const rewardimg = [
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/BIA- Award photo.png"
        alt=""
        onClick={() => window.open("/img/Award/BIA- Award photo.png")}
        role="presentation"
      />
    </div>,
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/receiving photo.png"
        alt=""
        onClick={() => window.open("/assets/img/Award/receiving photo.png")}
        role="presentation"
      />
    </div>,
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/brand icon award.jpg"
        alt=""
        onClick={() => window.open("/assets/img/Award/brand icon award.jpg")}
        role="presentation"
      />
    </div>,
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/brand icon.jpg"
        alt=""
        onClick={() => window.open("/assets/img/Award/brand icon.jpg")}
        role="presentation"
      />
    </div>,
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/award.jpeg"
        alt=""
        onClick={() => window.open("/assets/img/Award/award.jpeg")}
        role="presentation"
      />
    </div>,
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/Glory Award.png"
        alt=""
        onClick={() => window.open("/assets/img/Award/Glory Award.png")}
        role="presentation"
      />
    </div>,
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/Glory Award receiving.png"
        alt=""
        onClick={() =>
          window.open("/assets/img/Award/Glory Award receiving.png")
        }
        role="presentation"
      />
    </div>,
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/award44.jpeg"
        alt=""
        onClick={() => window.open("/assets/img/Award/award44.jpeg")}
        role="presentation"
      />
    </div>,
    <div style={{ width: "140px", padding: "0 6px" }}>
      <img
        style={{ width: "100%" }}
        src="/assets/img/Award/Times Business Award Image Final.jpg"
        alt=""
        onClick={() =>
          window.open("/assets/img/Award/Times Business Award Image Final.jpg")
        }
        role="presentation"
      />
    </div>,
  ];

  const reward = {
    0: {
      items: 2,
    },
    768: {
      items: 4,
    },
    1024: {
      items: 5,
      itemsFit: "contain",
    },
  };
  const jobcard = {
    0: {
      items: 1,
      stagePadding: 20, // Add left and right padding
    },
    768: {
      items: 2,
      stagePadding: 30, // Adjust for medium screens
    },
    1024: {
      items: 3,
      stagePadding: 40, // Adjust for larger screens
    },
  };
  

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchJobList();
    if (user) {
      dispatch(ProfileAction.GetSeekerDetails());
     
    }
  }, [user]);

  const fetchJobList = async () => {
    Notiflix.Loading.standard();
    try {
      const payload = {
        usertype: "Seeker",
        filter: "",
      };

      const json = await PostApiCall.postRequest(payload, "GetAllJobOpening");
      const res = await json.json();
      if (json.status === 200 || json.status === 201) {
        setJobsData(res?.data);
      } else {
        toast.error(res?.data, {
          autoClose: delay,
          toastId: 1,
        });
      }
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
    Notiflix.Loading.remove();
  };

  useEffect(() => {
    if (profile?.user?.fld_profileflag === 0) {
      setShowModal(true);
    }
  }, [profile?.user]);

  return (
    <div className="min-vh-100">
      <div
        className="position-relative overflow-hidden"
        style={{
          background: BANNER_BG,
        }}
      >
        <BannerCarousel />
      </div>
      {/* Hero Banner Section */}
      <SearchJob />
      {/* Stats Section */}

      {/* <BrowseJobs /> */}

     

      {/* Testimonials Section */}
      {/* <div className=" bg-light">

      <Container className="py-2 ">
        <h4 className="text-center mb-3 section-title text-dark">What Our Users Say</h4>
        <Row className="g-4 ">
          <TestimonialCarousel />
        </Row>
      </Container>
      </div> */}
      <div class="container mt-5">
        <div>
          <div class="row">
            <div class="col-md-8 col-sm-8 col-12">
              <div class="pr-30-md">
                <div class="section-heading center-holder">
                  <p
                    className="my-3 headingStyle"
                    style={{ fontSize: "1.7rem" }}
                  >
                    Betel Jobs
                  </p>

                  <div class="section-heading-line"></div>
                </div>
                <div class="section-heading-line-left"></div>
                <div class="text-content-big mt-20">
                  <p
                    style={{ color: PRIMARY_TEXT_COLOR, textAlign: "justify" }}
                  >
                    Welcome to Betel Jobs, your go-to platform for field audit
                    opportunities. We are dedicated to empowering job seekers by
                    creating a seamless, user-friendly environment that bridges
                    the gap between ambition & success and provide opportunities
                    at your doorstep. Whether you’re a pursuing your bachelors
                    or masters or a freelancer or retired or housewife or
                    someone exploring a new career path, we’re here to help you
                    find the perfect part-time or full time role in field
                    audits.
                    <br />
                    <strong>Our Mission</strong> <br />
                    To provide a dedicated portal for field audits with wide
                    geographical coverage across the globe. We aim to simplify
                    the part-time job search by offering a reliable,
                    user-friendly platform where opportunity meets flexibility.
                  </p>
                </div>
              </div>
            </div>
            <div
              class="col-md-4 col-sm-4 col-12 bg-light mb-1"
              style={{ margin: "auto", paddingTop: "3rem" }}
            >
              <img
                src={"/assets/img/rb_665.png"}
                alt="Community rewards"
                className="img-fluid "
              />
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-4 col-sm-4 col-12 bg-light"
              style={{ margin: "auto", paddingTop: "3rem" }}
            >
              <img
                src={"/assets/img/rb_9814.png"}
                alt="Community rewards"
                className="img-fluid "
              />
            </div>
            <div class="col-md-8 col-sm-8 col-12 my-5">
              <div class="pr-30-md">
                <div class="section-heading-line-left"></div>
                <div class="text-content-big mt-20">
                  <p
                    style={{ color: PRIMARY_TEXT_COLOR, textAlign: "justify" }}
                  >
                    <strong> Who We Are</strong>
                    <br />
                    Founded by a team of passionate professionals, Betel Jobs is
                    a product of well-established company{" "}
                    <span
                      onClick={() => window.open("https://trpwpartners.com/")}
                      style={{ color: PRIMARY_COLOR, cursor: "pointer" }}
                    >
                      TRPW Strategic Partners
                    </span>{" "}
                    based in India & USA supporting entrepreneurs and senior
                    executives across wide variety of industries and business
                    projects. Betel Jobs is built on the belief that everyone
                    deserves the chance to pursue their dream career and right
                    to earn more. others.
                    <br />
                    <br />
                    <strong>Why Betel Jobs</strong>
                    <br />
                    Join Us to discover how Betel Jobs can help you achieve your
                    goals and earn more in your own city or town. Browse
                    opportunities for field audits today. Together, we can build
                    a future with freedom and flexibility in your own way.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <TopHiring jobsData={jobsData} />
        <div class="container mt-5">
        <div className="mt-2">
          <div class="section-heading center-holder  ">
            <h4 className="text-center mb-3 section-title text-dark">
              Awards & Recognitions
            </h4>
            {/* <p
              className="mb-4 text-center pt-5 "
              style={{ fontSize: "1.7rem", color: "#000" }}
            >
              Awards & Recognitions
            </p> */}
            <div class="section-heading-line"></div>
          </div>
          <AliceCarousel
            responsive={reward}
            autoPlay
            mouseTracking
            autoPlayInterval={2000}
            animationDuration={5000}
            animationType="fadeout"
            infinite
            // disableButtonsControls
            items={rewardimg}
            disableDotsControls
            disableButtonsControls
          />
        </div>
        </div>

      {/* Clients Section */}
      <div className="py-5 my-3">
        <Container>
          <h4 className="text-center mb-3 section-title text-dark">We Serve</h4>
         
          <AliceCarousel
            responsive={responsive}
            autoPlay
            mouseTracking
            autoPlayInterval={2000}
            animationDuration={1000}
            animationType="slide"
            infinite
            disableDotsControls
            disableButtonsControls
            // disableButtonsControls
            items={items}
          />
        </Container>
      </div>
      {/* {jobsData?.length > 0 && (
        <div className="py-5 my-3">
          <Container>
            <h4 className="text-center mb-3 section-title text-dark">
              Job Opening
            </h4>

            <AliceCarousel
              responsive={jobcard}
              autoPlay
              mouseTracking
              autoPlayInterval={2000}
              animationDuration={1000}
              animationType="slide"
              infinite
              disableDotsControls
              disableButtonsControls
              // disableButtonsControls
              items={
                jobsData &&
                jobsData.map((ele) => (
                  <div style={{ margin: "0 10px" }}> 
                    <InteractiveJobCard JobsData={ele} />
                  </div>
                ))
              }
            />
          </Container>
        </div>
      )} */}

      {/* Basic Profile Modal */}
      {/* {showModal && (
        <CommonModal
          isOpen={showModal}
          toggle={() => setShowModal(false)}
          heading="Basic Details"
          modalSize="lg"
          contentBody={
            <BasicProfileContent
              // userData={profile?.user}
              setProfileModal={setShowModal}
            />
          }
          onConfirm={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
        />
      )} */}

      <style>
        {`
          .form-control:focus {
            box-shadow: none;
            border-color: ${BANNER_BG};
          }
          .card {
            transition: transform 0.3s ease;
          }
          .card:hover {
            transform: translateY(-5px);
          }
        `}
      </style>
    </div>
  );
};

export default HomePage;
